
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.385 9.166C3.796 5.883 6.606 3.333 10 3.333s6.204 2.55 6.615 5.833H3.385zM10 1.666c-4.595 0-8.334 3.739-8.334 8.334 0 .46.374.833.834.833h6.666v5c0 1.379 1.122 2.5 2.501 2.5 1.378 0 2.5-1.121 2.5-2.5a.833.833 0 10-1.667 0 .834.834 0 01-1.666 0v-5H17.5c.46 0 .833-.372.833-.833 0-4.595-3.738-8.333-8.333-8.333z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.385 9.166C3.796 5.883 6.606 3.333 10 3.333s6.204 2.55 6.615 5.833H3.385zM10 1.666c-4.595 0-8.334 3.739-8.334 8.334 0 .46.374.833.834.833h6.666v5c0 1.379 1.122 2.5 2.501 2.5 1.378 0 2.5-1.121 2.5-2.5a.833.833 0 10-1.667 0 .834.834 0 01-1.666 0v-5H17.5c.46 0 .833-.372.833-.833 0-4.595-3.738-8.333-8.333-8.333z"}})])
          )
        }
      }
    